import { FilterType } from "@/mk2/apps/bazaar/schemas";
import {
    serializeFilterForPathname,
    serializeFilterForQuery,
} from "@/mk/bazaar/product/filter/filterUtils";
import {
    bazaar_single_page_my_bazaar_category_filters_url,
    bazaar_single_page_my_bazaar_category_url,
    bazaar_single_page_product_grid_category_filters_url,
    bazaar_single_page_product_grid_category_url,
    bazaar_single_page_seller_category_filters_url,
    bazaar_single_page_seller_category_url,
    bazaar_single_page_wishlist_category_filters_url,
    bazaar_single_page_wishlist_category_url,
} from "@/mk/urls/functions";

export function bzCategoryUrl(cat, filter, filterType: FilterType) {
    const pathnameFilters = serializeFilterForPathname(filter);
    const query = serializeFilterForQuery(filter, true);

    if (filterType === FilterType.BAZAAR) {
        return pathnameFilters
            ? bazaar_single_page_product_grid_category_filters_url(cat, pathnameFilters, query)
            : bazaar_single_page_product_grid_category_url(cat, query);
    }
    if (filterType === FilterType.MY_BAZAAR) {
        return pathnameFilters
            ? bazaar_single_page_my_bazaar_category_filters_url(
                  filter.users[0],
                  cat,
                  pathnameFilters,
                  query,
              )
            : bazaar_single_page_my_bazaar_category_url(filter.users[0], cat, query);
    }
    if (filterType === FilterType.HER_BAZAAR) {
        return pathnameFilters
            ? bazaar_single_page_seller_category_filters_url(
                  filter.users[0],
                  cat,
                  pathnameFilters,
                  query,
              )
            : bazaar_single_page_seller_category_url(filter.users[0], cat, query);
    }
    if (filterType === FilterType.WISHLIST) {
        return pathnameFilters
            ? bazaar_single_page_wishlist_category_filters_url(
                  filter.users[0],
                  cat,
                  pathnameFilters,
                  query,
              )
            : bazaar_single_page_wishlist_category_url(filter.users[0], cat, query);
    }
    return "";
}
